import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { LeftOutlined } from "@ant-design/icons";
import profile from "../assets/profile.png";
import send from "../assets/orders/send.png";
import { Drawer, Rate } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { sendMessage } from "../redux/sendMSSlice";
import dayjs from "dayjs";
import verify from "../assets/productView/verify.png";
import { fetchCompanyData } from "../redux/companyDataSlice";
import { createChatAdmin } from "../redux/createChatAdminSlice";

const ChatAppWithAdmin = () => {
    const dispatch = useDispatch();
    const { admin_id } = useParams();

    const { chatid, statusChat, errorChat } = useSelector((state) => state.createChatAdmin);
    const { status: sendStatus } = useSelector((state) => state.sendMS);

    const [messages, setMessages] = useState([]);
    const [newMessage, setNewMessage] = useState("");

    const { companyData, statusComp, errorComp } = useSelector(
        (state) => state.companyData
    );

    console.log(companyData);

    useEffect(() => {
        dispatch(fetchCompanyData(admin_id));
    }, [dispatch]);

    useEffect(() => {
        if (statusChat == "idle" && admin_id) {
            dispatch(
                createChatAdmin()
            );
        }
    }, [dispatch, statusChat, admin_id]);

    // Load messages from chatid
    useEffect(() => {
        if (chatid?.messages) {
            const formattedMessages = chatid.messages.map((msg) => ({
                id: msg.id,
                text: msg.message,
                sender: msg.role,
                time: dayjs(msg.created_at).format("hh:mm A"),
                date: dayjs(msg.created_at).format("MMMM DD, YYYY"),
                createdAt: msg.created_at,
            }));

            const sortedMessages = formattedMessages.sort((a, b) =>
                dayjs(a.createdAt).isAfter(dayjs(b.createdAt)) ? 1 : -1
            );

            setMessages(sortedMessages);
        }
    }, [chatid]);


    // Handle sending messages
    const handleSendMessage = () => {
        if (newMessage.trim()) {
            const messageData = {
                chat_id: chatid.id,
                message: newMessage,
            };

            // Dispatch sendMessage action
            dispatch(sendMessage(messageData))
                .then(() => {
                    const now = dayjs(); // Current time
                    setMessages((prev) => [
                        ...prev,
                        {
                            id: prev.length + 1,
                            text: newMessage,
                            sender: "user",
                            time: now.format("hh:mm A"),
                            date: now.format("MMMM DD, YYYY"),
                            createdAt: now.toISOString(),
                        },
                    ]);

                    setNewMessage("");
                })
                .catch((err) => {
                    console.error("Failed to send message:", err);
                });
        }
    };

    const [open, setOpen] = useState(false);
    const showDrawer = () => setOpen(true);
    const onClose = () => setOpen(false);

    return (
        <div className="chat-container">
            <div className="bg-[#FCFBFA] px-20 max-lg:px-5 py-8 sticky top-0">
                <Link to="/allpreviewrequests" className="flex items-center text-[#283D63] font-semibold">
                    <LeftOutlined />
                    <p className="ml-3">Back to my preview requests</p>
                </Link>
                <div className="flex items-center justify-between mt-8">
                    <div className="flex items-center">
                        {companyData?.admin?.image ? (
                            <img
                                src={`https://service.samoolah.com${companyData.admin.image}`}
                                className="w-[58px] max-lg:w-[45px] mr-5 rounded-full"
                                onError={(e) => (e.target.src = profile)}
                            />
                        ) : (
                            <img src={profile} className="w-[58px] max-lg:w-[45px] mr-5" />
                        )}
                        <p className="text-[#14294F] font-semibold text-2xl max-lg:text-xl">
                            {companyData?.admin?.name} {companyData?.agent?.last_name}
                        </p>
                    </div>
                    <button onClick={showDrawer} className="flex items-center">
                        <div className="bg-[#FE6625] rounded-full p-1"></div>
                        <div className="bg-[#FE6625] rounded-full p-1 ml-1"></div>
                        <div className="bg-[#FE6625] rounded-full p-1 ml-1"></div>
                    </button>

                    <Drawer size='large' title={<span className="bg-[#C8E9C0] w-[100px] rounded-xl px-4 py-2 text-white flex justify-end ml-auto">{companyData?.admin?.is_available == "1" ? "Available" : "Not available"}</span>} onClose={onClose} open={open}>
                        <div className="mx-auto">
                            <div className="text-center">
                                {companyData?.agent?.image ? (
                                    <img
                                        src={`https://service.samoolah.com${companyData.agent.image}`}
                                        className="w-[88px] max-lg:w-[45px] mx-auto rounded-full"
                                        onError={(e) => (e.target.src = profile)}
                                    />
                                ) : (
                                    <img src={profile} className="w-[58px] max-lg:w-[45px] mx-auto" />
                                )}
                                <p className="text-[#14294F] font-semibold text-2xl max-lg:text-xl my-5 text-center">
                                    {companyData?.admin?.name} {companyData?.admin?.last_name}
                                </p>
                                <Rate disabled defaultValue={companyData?.admin?.rates} />
                            </div>
                            <div className="text-center">
                                <p className="text-lg text-[#283D63] mt-3 font-semibold">Specialties:</p>
                                <div className="grid grid-cols-3 gap-10 max-xl:grid-cols-1 mb-5 mx-12 max-lg:mx-4">
                                    {
                                        companyData?.categorys?.map((cat, index) => (
                                            <div>
                                                <div className={`relative`}>
                                                    <div className="bg-white rounded-full w-[90px] h-[90px] max-lg:w-[40px] max-lg:h-[40px] flex items-center mx-auto my-5 p-4" style={{ boxShadow: "0px 2px 10px 6px #c3c3c326" }}>
                                                        <img src={`https://service.samoolah.com/${cat?.category?.icon}`} className="mx-auto max-lg:w-[40px]" width="60px" />
                                                    </div>
                                                </div>
                                                <p className="text-[#63718A]">{cat?.category?.name_en}</p>
                                            </div>
                                        ))
                                    }

                                </div>
                            </div>
                            <div>
                                <div className="lg:flex items-center">
                                    <p className="text-[#283D63] font-semibold text-lg">
                                        Technologies:
                                    </p>
                                    <div className="flex items-center flex-wrap">
                                        {companyData?.used_technologys?.flat().map((tech, index) => (
                                            <div
                                                key={index}
                                                className="text-[#FE9B71] rounded-full font-semibold border-2 border-[#FE9B71] px-5 py-1 mt-5 mb-5 mx-2"
                                            >
                                                {tech.technology}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                            {/* <div>
                                <p className="text-lg text-[#283D63] mt-3 font-semibold">Reviews:</p>
                                <div>
                                    {
                                        companyData.length > 0 ?
                                            companyData?.map((rate, index) => (
                                                <div className="mb-4" key={index}>
                                                    <div className="flex items-center justify-between">
                                                        <div className="flex items-center my-4 max-lg:mr-2">
                                                            <div>
                                                                <img src={rate.user?.image == null ? profile : `https://samoolah.com/${rate.user?.image}`} className="w-[50px] max-lg:w-[30px]" />
                                                            </div>
                                                            <div className="ml-3 font-semibold">
                                                                <p className="text-[#14294F] text-lg mb-1">{rate.user?.name}</p>
                                                                <Rate disabled defaultValue={rate.rate} className="" />
                                                            </div>
                                                        </div>

                                                        <div className="flex items-center">
                                                            <img src={verify} className="w-[30px]" />
                                                            <p className="text-[#6575CC] ml-2 text-lg">
                                                                Verified Purchase
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <p className="text-[#737E91] text-lg mt-3">
                                                        {rate.rate_comment}
                                                    </p>
                                                </div>
                                            ))
                                            :
                                            <p className="text-[#63718A] text-lg">No reviews added yet</p>

                                    }

                                </div>
                            </div> */}
                        </div>
                    </Drawer>
                </div>
            </div>

            {/* Chat Messages */}
            <div className="chat-box px-20 max-lg:px-5 py-5 pb-20">
                {(() => {
                    let previousDate = null;
                    return messages.map((message) => {
                        const showDate = message.date !== previousDate;
                        previousDate = message.date;

                        return (
                            <div key={message.id}>
                                {showDate && (
                                    <div className="text-center text-[#283D63] font-medium text-xl mb-10">
                                        {message.date}
                                    </div>
                                )}
                                <div className="mb-3">
                                    <div
                                        className={`chat-message w-2/5 max-lg:w-full text-lg px-8 py-4 ${message.sender === "user"
                                            ? "user-message bg-[#EF9D7A] text-[#FCFBFA] rounded-l-3xl rounded-tr-3xl rounded-br-lg ml-auto"
                                            : "agent-message bg-[#FCFBFA] text-[#717D91] border-2 border-[#FFD3C4] rounded-r-3xl rounded-tl-3xl rounded-bl-lg"
                                            }`}
                                    >
                                        <p>{message.text}</p>
                                    </div>
                                    <p
                                        className={`text-[#EF9D7A] ${message.sender === "user" ? "text-end mt-1" : ""
                                            }`}
                                    >
                                        {message.time}
                                    </p>
                                </div>
                            </div>
                        );
                    });
                })()}
            </div>


            <div className="bg-white input-box fixed bottom-0 w-full border-t-2 border-[#EAA182]">
                <div className="flex items-center justify-between px-20 max-lg:px-5 py-5">
                    <input
                        type="text"
                        value={newMessage}
                        onChange={(e) => setNewMessage(e.target.value)}
                        placeholder="Type text here..."
                        className="border-0 w-full mr-5"
                    />
                    <button onClick={handleSendMessage}>
                        <img src={send} className="w-[38px]" />
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ChatAppWithAdmin;